import React from "react";
import { getTrackColors, TRACK_KEYS } from "../utils/trackHelpers";
import { UnifiedPopup, getPopupGradientFromTrackKey } from "../../common/UnifiedPopup";
import { BattleKartLoadingGifURL, LoadingAnimationURL } from "../../../consts/assetUrls";

interface RemoveConfirmationModalProps {
  sessionToRemove: {
    sessionId: string;
    variantTitle: string;
    productTitle: string;
    trackKey: string;
    allSessionsForVariant: any[];
  } | null;
  isRemoving?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RemoveConfirmationModal: React.FC<RemoveConfirmationModalProps> = ({ sessionToRemove, isRemoving = false, onConfirm, onCancel }) => {
  if (!sessionToRemove) return null;

  const colors = getTrackColors(sessionToRemove.trackKey);
  const isArcadeCard = sessionToRemove.trackKey === TRACK_KEYS.ARCADE;
  const gradientStyle = getPopupGradientFromTrackKey(sessionToRemove.trackKey);

  return (
    <UnifiedPopup isOpen={!!sessionToRemove} onClose={onCancel} trackKey={sessionToRemove.trackKey} maxWidth="840px">
      {isRemoving ? (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-[20px]">
          {sessionToRemove.trackKey === TRACK_KEYS.BK ? (
            <img src={BattleKartLoadingGifURL} alt="Battle Kart Loading" className="tw-w-[120px] tw-h-[120px] tw-object-contain" />
          ) : (
            <img
              src={LoadingAnimationURL}
              alt="Loading"
              className="tw-w-[120px] tw-h-[120px] tw-object-contain"
            />
          )}
          <p className="tw-text-white tw-text-[18px] tw-font-[500] tw-mt-[16px]">Removing...</p>
        </div>
      ) : (
        <>
          <div className="tw-text-center tw-mb-[20px]">
            <h2
              className="tw-text-white tw-text-[20px] lg:tw-text-[24px] tw-font-[700]"
              style={{
                background: gradientStyle,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Remove from cart?
            </h2>
          </div>
          <p className="tw-text-white tw-text-[14px] lg:tw-text-[16px] tw-text-center tw-mb-[16px] tw-leading-relaxed tw-px-[19px] lg:tw-px-[40px]">
            Are you sure you want to remove this {isArcadeCard ? "item" : "session"} from your cart?
          </p>
          <div className="tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-mt-[24px] tw-flex-wrap">
            <button
              onClick={onConfirm}
              className="tw-flex tw-items-center tw-justify-center tw-text-center tw-text-white tw-py-[12px] tw-px-[32px] tw-font-bold tw-text-[16px] tw-rounded-[100px] tw-cursor-pointer tw-transition-all tw-duration-200 hover:tw-opacity-90 tw-w-full lg:tw-w-auto lg:tw-min-w-[140px]"
              style={{ background: gradientStyle }}
            >
              Confirm
            </button>
            <button
              onClick={onCancel}
              className={`tw-flex tw-items-center tw-justify-center tw-text-center tw-py-[8px] tw-px-[30px] lg:tw-px-[40px] tw-border-[1px] tw-rounded-[100px] tw-cursor-pointer tw-w-full lg:tw-w-auto lg:tw-min-w-[140px] tw-text-[16px] lg:tw-text-[18px] tw-font-[700] ${colors.cancelButtonText}`}
            >
              Close
            </button>
          </div>
        </>
      )}
    </UnifiedPopup>
  );
};
